export const MODAL_LIGHTBOX_CLASSNAME = "web3modal-modal-lightbox";
export const MODAL_CONTAINER_CLASSNAME = "web3modal-modal-container";
export const MODAL_TITLE_CLASSNAME = "web3modal-modal-title";
export const MODAL_TITLE_CLOSE_CLASSNAME = "web3modal-modal-title-close-icon"
export const MODAL_HITBOX_CLASSNAME = "web3modal-modal-hitbox";
export const MODAL_CARD_CLASSNAME = "web3modal-modal-card";
export const MODAL_CARD_CON_CLASSNAME = "web3modal-modal-card-con";

export const PROVIDER_WRAPPER_CLASSNAME = "web3modal-provider-wrapper";
export const PROVIDER_CONTAINER_CLASSNAME = "web3modal-provider-container";
export const PROVIDER_ICON_CLASSNAME = "web3modal-provider-icon";
export const PROVIDER_NAME_CLASSNAME = "web3modal-provider-name";
export const PROVIDER_DESCRIPTION_CLASSNAME = "web3modal-provider-description";

export const CONNECT_BUTTON_CLASSNAME = "web3modal-connect-button";
